import { configureStore } from "@reduxjs/toolkit";

import { baseApi } from "./baseApi/baseApi";
import themeSettingSlice from "./themeSettingSlice";
import sidebarSlice from "./sidebarSlice";
import authSlice from "./authSlice";
import sessionSlice from "./sessionSlice";

const store = configureStore({
  reducer: {
    // ajout du RTK Query "API slice" pour la mise en cache des données
    [baseApi.reducerPath]: baseApi.reducer,
    // ajout des autres reducers
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    auth: authSlice,
    session: sessionSlice,
  },
  // ajouter le RTK Query API middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // désactiver la vérification de sérialisation pour les actions et les états
    }).concat(baseApi.middleware),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
